import { render, staticRenderFns } from "./AvatarCropper.vue?vue&type=template&id=25cb1379&scoped=true"
import script from "./AvatarCropper.vue?vue&type=script&lang=js"
export * from "./AvatarCropper.vue?vue&type=script&lang=js"
import style0 from "./AvatarCropper.vue?vue&type=style&index=0&id=25cb1379&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cb1379",
  null
  
)

export default component.exports